import React from 'react';
import { Modal, ModalBody, Button } from 'react-bootstrap';
/*import successImg from "../../common/images/success1.png";*/
export const SuccessModal = ({ show, message }) => {
  return (
    <Modal size="md" show={show} centered>
      <div className="modal-content success-mdl-popup">
        <ModalBody className="px-4 py-5 text-center">
          <div className="avatar-sm mb-4 mx-auto confirm-mdl-title">
            {/* <div className='success-mdl-titletxt'> <img src={successImg} alt='' /> </div> */}
            <div className='success-mdl-titletxt success-mdl-icon'> <i className='bx bxs-check-circle'></i> </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{message || 'Record Added Successfully'}</p>
        </ModalBody>
      </div>
    </Modal>
  );
};

